import React, { Component } from 'react';
import { connect } from 'react-redux';
import '../../user/component/login.scss';
import {Button, message } from 'antd';
import { fromValidate } from '../../../helpers';
import { history } from '../../../helpers'
import {login } from '../../user/action/user.actions'
import { Link } from "react-router-dom";
import logo from '../../../images/logo.png';


class Admin extends Component {
	constructor(props) {
		super(props);
		this.state = {
			formError: {},
			formSubmit: false,
			admin: {
				username: '',
				password: ''
			},
		}
	}

	handleChange = (e) => {
		const admin = Object.assign({}, this.state.admin)
		const name = e.target.name;
		const value = e.target.value;
		var letters = /^[0-9]+$/;
		if (name == 'phone') {
			if (value.match(letters) || e.target.value == '') {
				admin[name] = value;
			}
		} else {
			admin[name] = value;
		}

		this.setState({ admin });

		if (this.state.formSubmit) {
			this.setState({ formError: {} })
			const formValidation = fromValidate(this.fromNode);
			if (!formValidation.valid) {
				this.setState({ formError: formValidation.invalidationEle })
			}
		}
	}

	handleSubmit = (e) => {
		e.preventDefault();
		const { dispatch } = this.props;
		const { admin } = this.state;
		if (!admin.username) {
			message.error('Please enter the valid admin name');
			return;
		}
		if (!admin.password) {
			message.error('Please enter Password');
			return;
		}

		dispatch(login(admin.username, admin.password, 'A'))
		.then((res) => {
			if (res.token) {
				history.push('/')
			}
		})
		.catch(e => {
			message.error(e.message);
		})
	}
	render() {
		const { admin} = this.state;
		return (
			<div className='login-container'>
				<div className='login-box'>
					<div className='logo-box-logo'>
						<Link to="/">
							<img className='login-logo-image' src={logo}></img>
						</Link>
					</div>
					<div className='txt-login'>Login to your Account</div>
					<form ref={node => this.fromNode = node}
						onSubmit={(e) => { this.handleSubmit(e) }}>
						<div>
							{
								
								<div>
									<div>
										<input
											required
											id="name"
											type="text"
											className='form-textfield-containt'
											placeholder="User Name"
											value={admin.username}
											name="username"
											onChange={(e) => { this.handleChange(e) }}
										/>
									</div>
									<div className="otp-box-con">
										<input
											required
											type="password"
											className='form-textfield-containt'
											placeholder="Password"
											value={admin.password}
											name="password"
											onChange={(e) => { this.handleChange(e) }}
										/>
									</div>
								</div>
							}
							{
								<div className="login-footer-buttons">
									<Button htmlType="submit" className='btn-signin'>Sign in</Button>
								</div>
							}
						</div>
					</form>
				</div>
			</div>
		)
	}
}

function mapStateToProps(state) {
	const { admin } = state.authentication;
	return {
		admin,
	}
}
export default connect(mapStateToProps)(Admin);